import { render } from "./SafeAreaTop.vue?vue&type=template&id=f0f92c8a&scoped=true"
import script from "./SafeAreaTop.vue?vue&type=script&lang=js"
export * from "./SafeAreaTop.vue?vue&type=script&lang=js"

import "./SafeAreaTop.vue?vue&type=style&index=0&id=f0f92c8a&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f92c8a"],['__file',"src/components/SafeAreaTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0f92c8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0f92c8a', __exports__)) {
    console.log('reload')
    api.reload('f0f92c8a', __exports__)
  }
  
  module.hot.accept("./SafeAreaTop.vue?vue&type=template&id=f0f92c8a&scoped=true", () => {
    console.log('re-render')
    api.rerender('f0f92c8a', render)
  })

}


export default __exports__